import type { Movie } from "../types";

const uniqueMovies = (movies: Movie[]): Movie[] => {
  const result = new Set<number>();

  return movies.filter((movie) => {
    if (result.has(movie.movie_id)) return false;

    result.add(movie.movie_id);
    return true;
  });
};

export default uniqueMovies;